export default __webpack_public_path__ + "static/media/close.7a526c08.svg";